<!-- 新建/编辑平台优惠管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app platform">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="标签类型" prop="type">
              <div class="list-img-box">
                <el-select v-model="formValidate.type" placeholder="请选择标签类型" :style="{width:'100%'}">
                  <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="优惠政策标签" prop="title" v-if="formValidate.type == 1">
              <div class="list-img-box">
                <el-input placeholder="请输入优惠政策标签" v-model="formValidate.title"></el-input>
              </div>
            </el-form-item>
            <el-row :style="{ margin:'0 !important'}" v-if="formValidate.type == 1">
              <el-col :span="8" :style="{ padding:'0 !important'}">
                <el-form-item label="标签背景颜色" prop="backgroundColor">
                  <div class="list-img-box" :style="{display:'flex',flexDirection:'row',lineHeight:'38px'}">
                    <el-color-picker v-model="formValidate.backgroundColor"></el-color-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8" :style="{ padding:'0 !important'}">
                <el-form-item label="标签字体颜色" prop="wordColor">
                  <div class="list-img-box" :style="{display:'flex',flexDirection:'row',lineHeight:'38px'}">
                   <el-color-picker v-model="formValidate.wordColor"></el-color-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div :style="{display:'flex',flexDirection: 'row',paddingTop:'10px'}">
                  <div :style="{backgroundColor:formValidate.backgroundColor,color:formValidate.wordColor,borderRadius:'5px',padding:'2px 5px'}">{{ formValidate.title }}</div>
                </div>
              </el-col>
            </el-row>
            <el-form-item label="优惠政策内容" prop="content">
              <div class="list-img-box">
                <el-input type="textarea" placeholder="请输入优惠政策内容" rows="2" v-model="formValidate.content"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="优惠政策规则" prop="rule" v-if="formValidate.type == 1">
              <div class="list-img-box">
                <el-input type="textarea" placeholder="请输入优惠政策规则" rows="6" v-model="formValidate.rule"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="优惠开始时间" prop="startTime" v-if="formValidate.type == 1">
              <div class="list-img-box">
                <el-date-picker :style="{width:'100%'}" v-model="formValidate.startTime" :picker-options="pickerEffective" type="datetime" placeholder="请选择优惠开始时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="优惠结束时间" prop="endTime" v-if="formValidate.type == 1">
              <div class="list-img-box">
                <el-date-picker :style="{width:'100%'}" v-model="formValidate.endTime" :picker-options="pickerInvalid" type="datetime" placeholder="请选择优惠结束时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
              </div>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'PlatformDiscountManagementOperation',
    data () {
      return {
        formValidate: {
          type: 1,//类型
          title: '',//优惠政策标签
          backgroundColor: '',//标签背景颜色
          wordColor: '',//标签字体颜色
          content:'',//优惠政策内容
          rule:'',//优惠政策规则
          startTime:'',//优惠开始时间
          endTime:'',//优惠结束时间
        },
        typeList:[{name:'优惠政策',id:1},{name:'退订政策',id:2}],//1.优惠政策 2.退订政策
        ruleValidate: { //城市名称非空验证
          type: [
            { required: true, message: '请选择标签类型', trigger: 'change'}
          ],
          title: [
            { required: true, message: '请输入优惠政策标签', trigger: 'blur'}
          ],
          backgroundColor: [
            { required: true, message: '请选择标签背景颜色', trigger: 'change'}
          ],
          wordColor: [
            { required: true, message: '请选择标签字体颜色', trigger: 'change'}
          ],
        },
        pickerEffective:{
          disabledDate: time => {
            let endDateVal = this.formValidate.endTime;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime()
            }
          }
        },
        pickerInvalid:{
          disabledDate: time => {
            let beginDateVal = this.formValidate.startTime;
            if (beginDateVal) {
              return (
                time.getTime() <
                new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
              )
            }
          }
        }
      }
    },
    methods: {
      // 获取时间
      getTime(time) {
        if (time == undefined || time == null || time == "") {
          return null;
        } else {
          const d = new Date(time);
          const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate()) + ' ' + this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds());
          return resDate;
        }
      },
      // 时间是否需要补0
      p(s) {
        return s < 10 ? '0' + s : s
      },
      // 提交上传
      onConfirm() {
        if(new Date(this.formValidate.startTime) > new Date(this.formValidate.endTime)){
          this.$message({
            type: 'error',
            message: '优惠开始时间不能大于优惠结束时间！'
          });
          return;
        }
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  title:this.formValidate.title,
                  type:this.formValidate.type,
                  color:this.formValidate.backgroundColor+'|'+this.formValidate.wordColor,
                  content:this.formValidate.content,
                  rule:this.formValidate.rule,
                  startTime:this.formValidate.startTime == null ||  this.formValidate.startTime == ''? "":this.getTime(this.formValidate.startTime),
                  endTime:this.formValidate.endTime == null ||  this.formValidate.endTime == ''? "":this.getTime(this.formValidate.endTime),
                  status:1
                }
              } else {
                params = {
                  id:this.$route.query.data.id,
                  title:this.formValidate.title,
                  type:this.formValidate.type,
                  color:this.formValidate.backgroundColor+'|'+this.formValidate.wordColor,
                  content:this.formValidate.content,
                  rule:this.formValidate.rule,
                  startTime:this.formValidate.startTime == null ||  this.formValidate.startTime == ''? "":this.getTime(this.formValidate.startTime),
                  endTime:this.formValidate.endTime == null ||  this.formValidate.endTime == ''? "":this.getTime(this.formValidate.endTime),
                  status:1
                }
                title = "编辑";
              }
              this.$api.saveOrUpdatePreferential({parameter: JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/PlatformDiscountManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/PlatformDiscountManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.title = this.$route.query.data.title;
        this.formValidate.type = this.$route.query.data.type;
        this.formValidate.backgroundColor = this.$route.query.data.color.split("|")[0];
        this.formValidate.wordColor = this.$route.query.data.color.split("|")[1];
        this.formValidate.content = this.$route.query.data.content;
        this.formValidate.rule = this.$route.query.data.rule;
        this.formValidate.startTime = this.$route.query.data.startTime;
        this.formValidate.endTime = this.$route.query.data.endTime;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/PlatformDiscountManagementOperation.vue